
import { mapGetters } from 'vuex'
import UserInfoBox from '@/components/UserInfoBox'
import PzTabs from '@/components/pz-tabs'
import BargainSellerList from '@/components/Bargain/seller'
import GoodsListPage from '@/components/GoodsListPage'
import SellerEmpty from '@/components/Bargain/seller/Empty'

export default {
	components: {
		UserInfoBox,
		PzTabs,
		BargainSellerList,
		GoodsListPage,
		SellerEmpty
	},
	data() {
		return {
            query: null,
			// 列表数据
			pageList: [],
			// 二级 tabs 选中
			radio: null,
			// 数据加载状态
			loading: false,
			// 分页器数据
			pageInfo: {
				page: 1,
				pageSize: 5,
				total: 0
			}
		}
	},
	computed: {
		...mapGetters({
			centerMenu: 'menu/centerMenu',
			userAccount: 'user/userAccount'
		})
	},
	async mounted() {
		// await this.setMenuDot()
		this.getListData()
        await this.$store.dispatch('user/UserCenterStatistics')
        await this.$store.dispatch('menu/onSetCenterDotMenu', {
            menu: this.centerMenu,
            userAccount: this.userAccount
        })
	},
	methods: {
        // 清楚未读
        async clearUnread(){
            // 请求参数
            const par = {
                action: {}
            }
            const res = await this.$api.bargainAllCanelAPI(par)
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.$message.success(res.info)
            await this.$store.dispatch('user/UserCenterStatistics')
            await this.$store.dispatch('menu/onSetCenterDotMenu', {
                menu: this.centerMenu,
                userAccount: this.userAccount
            })
        },
        // 查询
        onSearchOrder(){
            console.log(this.query,'123123');
            this.getListData()
        },
		/**
		 * 设置小红点
		 */
		// async setMenuDot() {
		// 	const par = {
		// 		action: {
		// 			buyer: false
		// 		}
		// 	}
		// 	const res = await this.$api.getBargainDot(par)
		// 	if (!res.success) {
		// 		this.$message.error(res.info)
		// 		return
		// 	}
		// 	const { bargainFailedDotNum, bargainInProgressDotNum, bargainPayCancel, bargainPayedDotNum, bargainPayingDotNum, bargainSuccessDotNum } = res.data
		// 	const subMenuDotTotal = {
		// 		FAILED: bargainFailedDotNum, // 砍价失败
		// 		IN_PROGRESS: bargainInProgressDotNum, // 砍价中
		// 		SUCCESS: bargainSuccessDotNum, // 砍价成功
		// 		NOT_PAID: bargainPayingDotNum, // 待买家支付
		// 		PAID: bargainPayedDotNum, // 买家已支付
		// 		CANCELLED: bargainPayCancel // 已取消
		// 	}
		// },
		/**
		 *	获取列表数据
		 */
		async getListData() {
			try {
				this.pageList = []
				this.loading = true
				// 请求参数
				const par = {
					action: {
                        goodsNo: this.query
                    },
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize
				}
				const res = await this.$api.bargainSellerManyList(par)
				if (!res.success) {
					this.$message.error(res.info)
					return
				}

				const { records, page, total } = res.data
				records?.forEach(item => {
					item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
				})
				this.pageList = records
				this.pageInfo.page = Number(page)
				this.pageInfo.total = Number(total)
				this.loading = false
			} catch (error) {
				this.loading = false
				this.$message.error(error.message)
			}
		},
		/**
		 *currentPage 页码值改变时触发事件
		 */
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getListData()
		},
		/**
		 * pageSize 每页展示数据条数改变时触发事件
		 */
		handleSizeChange(pageSize) {
			this.pageInfo = { page: 1, pageSize }
			this.getListData()
		}
	}
}
